export const GET_LESSON_RATINGS = 'lesson-ratings/GET_LESSON_RATINGS';
